'use client';

import { LayoutGrid } from 'lucide-react';
import { CardProps } from '@/shared/properties/CardProps'

export function GridCard({ title, children }: CardProps) {
  return (
    <div className="rounded-xl border border-gray-200 bg-white shadow-sm p-6">
        <div className="flex items-center gap-2 mb-5">
            <LayoutGrid className="h-4 w-4 text-gray-500"/>
            <h2 className="text-base font-semibold text-gray-800">{title}</h2>
        </div>
        <div className="flex flex-row gap-4 mb-6">
            {children}  
        </div>
    </div>
  );
}
